/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'fabric.editor.headingLink.ascSortingLabel': '昇順',
  'fabric.editor.headingLink.copied': 'コピーしました',
  'fabric.editor.headingLink.copyAnchorLink': '見出しへのリンクをコピー',
  'fabric.editor.headingLink.copyAriaLabel': 'コピー',
  'fabric.editor.headingLink.descSortingLabel': '降順',
  'fabric.editor.headingLink.failedToCopy': 'コピーできませんでした。',
  'fabric.editor.headingLink.noneSortingLabel': 'なし',
  'fabric.editor.inlineComment.marker.end': 'インライン コメント終了',
  'fabric.editor.inlineComment.marker.start': 'インライン コメント開始',
};
